import React from 'react';
import cn from './../../lib/bem/index';

import './link_component.scss';

const LinkComponent = (props) => {

    const classes = cn("linkComponent");

    return (
        <div className={classes()}> 
            <img src={props.img} alt={props.img}/>
            <button onClick={props.action}>{props.title}</button>
        </div>
    );
};

export default LinkComponent;